module.exports = __webpack_public_path__ + "9487f483d6e1daec5419b7bddc91a687.svg";